package com.swetdot.swetgram.data.media

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow

/** Browser audio playback; Ogg/Opus recording remains available on Android. */
class BrowserVoicePlayer : VoicePlayer {
    private val mutableState = MutableStateFlow(VoicePlaybackState())
    override val state = mutableState.asStateFlow()
    private var audio: dynamic = null

    override fun toggle(messageId: String, url: String, durationMs: Long) {
        if (mutableState.value.messageId != messageId) {
            stop()
            audio = js("new Audio(url)")
            mutableState.value = VoicePlaybackState(messageId = messageId, durationMs = durationMs, isPreparing = true)
            audio.ontimeupdate = { _: dynamic ->
                mutableState.value = mutableState.value.copy(positionMs = ((audio.currentTime as Double) * 1000).toLong())
            }
            audio.onplaying = { _: dynamic -> mutableState.value = mutableState.value.copy(isPreparing = false, isPlaying = true) }
            audio.onpause = { _: dynamic -> mutableState.value = mutableState.value.copy(isPlaying = false) }
            audio.onended = { _: dynamic -> mutableState.value = mutableState.value.copy(isPlaying = false, positionMs = 0) }
            audio.onerror = { _: dynamic -> stop() }
        }
        if (mutableState.value.isPlaying) audio.pause()
        else audio.play().catch { _: dynamic -> stop() }
    }

    override fun seekTo(messageId: String, positionMs: Long) {
        if (mutableState.value.messageId == messageId) audio.currentTime = positionMs.coerceIn(0, mutableState.value.durationMs) / 1000.0
    }

    override fun cycleSpeed(messageId: String) {
        if (mutableState.value.messageId != messageId) return
        val speed = when (mutableState.value.speed) { 1f -> 1.5f; 1.5f -> 2f; else -> 1f }
        audio.playbackRate = speed.toDouble()
        mutableState.value = mutableState.value.copy(speed = speed)
    }

    override fun stop() {
        if (audio != null) {
            audio.ontimeupdate = null
            audio.onplaying = null
            audio.onpause = null
            audio.onended = null
            audio.onerror = null
            audio.pause()
            audio.src = ""
        }
        audio = null
        mutableState.value = VoicePlaybackState()
    }
}
